import { render, staticRenderFns } from "./promot.vue?vue&type=template&id=a9c8259c&scoped=true"
import script from "./promot.vue?vue&type=script&lang=js"
export * from "./promot.vue?vue&type=script&lang=js"
import style0 from "./promot.vue?vue&type=style&index=0&id=a9c8259c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9c8259c",
  null
  
)

export default component.exports